import { makeAutoObservable } from "mobx";
import ApiStore from "../ApiStore";
import { AxiosResponse } from "axios";
import { EmbedUrlResult, GuestTokenResult } from "../../../api/Report";


class ReportStore {

    private _api: ApiStore;

    CommunityVendorListGUID: string = "23870cba-b084-4533-a940-9ee7212c3569"
    VMSTrusteeSalesProgressGUID: string = "aa76b5fb-52bf-4f99-841b-896cebb421dd"
    ViolationChartGUID: string = "7582413a-0b23-4bed-bafa-9d363a91e94d"

    constructor(api: ApiStore) {
        makeAutoObservable(this);
        this._api = api;
    }

    getReportUrl = ():string => {
        return this._api.ReportAndDashboardClient.reportAndDashboardUrl
    }

    getEmbedUrl = async (reportId: string, community: string): Promise<EmbedUrlResult> => {
        return await this._api.ReportAndDashboardClient.getEmbedUrl(reportId, community)
    }

    getGuestToken = async (dashboardId: string, community: string): Promise<GuestTokenResult> => {
        return await this._api.ReportAndDashboardClient.getGuestToken(dashboardId, community)
    }

    PaidInvoiceDownload = async (id: string): Promise<AxiosResponse<Blob> | null> => {
        return await this._api.ReportAndDashboardClient.PaidInvoiceDownload(id);
    }

}
export default ReportStore
